/**
 * What the next availability response does with the selected dates:
 * - `validate`: clear them when they are no longer available (default)
 * - `pick-first`: select the first available date (no dates yet, or a new minDate)
 * - `pick-first-and-emit`: the same, and emit it so the host stores it (a code was entered)
 * - `keep-selection`: leave them as they are, once (a code was removed)
 */
export type AvailabilityResolution =
	'validate' | 'pick-first' | 'pick-first-and-emit' | 'keep-selection';

/** A removed code keeps a complete selection; any other scope change re-picks. */
export function shouldKeepSelection(change: {
	suppressChanged: boolean;
	groupRemoved: boolean;
	promotionRemoved: boolean;
	hasSelectedDates: boolean;
}): boolean {
	return (
		!change.suppressChanged &&
		change.hasSelectedDates &&
		(change.groupRemoved || change.promotionRemoved)
	);
}
